import styled from 'styled-components'
import StarIcon from '@mui/icons-material/Star'
import Tooltip from '@components/UI/Tooltip/Tooltip'
import {screenS} from '@theme/vars'

export const ItemWrapper = styled.div`
  line-height: 1.2;
  color: #222;
  padding: 16px 10px;
  border-bottom: 1px solid #dfdfdf;
  display: flex;
  justify-content: space-between;
  flex-direction: row;

  &:hover {
    background-color: #fafafa;
  }

  @media screen and (max-width: ${screenS}) {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 0px;
  }
`

export const DesktopDateWrapper = styled.div`
  align-self: flex-start;

  @media screen and (max-width: ${screenS}) {
    display: none;
  }
`

export const MobileDateWrapper = styled.div`
  display: none;

  @media screen and (max-width: ${screenS}) {
    display: flex;
  }
`

export const ItemContentWrapper = styled.div`
  margin-left: 24px;

  @media screen and (max-width: ${screenS}) {
    margin-left: 10px;
    width: calc(100% - 50px);
  }
`

export const StarIconStyled = styled(StarIcon)`
  width: 16px;
  height: 16px;
  color: #707070;
  margin-right: 10px;
  margin-top: 2px;
`

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
export const Title = styled.h3`
  grid-area: title;

  @media screen and (max-width: ${screenS}) {
    margin-top: 4px;
  }
`

export const PublicationsCountWrapper = styled.div`
  margin-top: 6px;

  @media screen and (max-width: ${screenS}) {
    margin-top: 4px;
  }
`

export const StyledTooltip = styled(Tooltip)`
  font-size: 14px;
`

export const ImageWrapper = styled.div`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 2px;
  display: flex;
  margin-left: 23px;
  align-self: flex-start;

  @media screen and (max-width: ${screenS}) {
    margin-left: 0px;
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-end;

  & * + button {
    margin-left: 28px;
  }

  @media screen and (max-width: ${screenS}) {
    margin-top: 8px;
    margin-left: 50px;
    align-self: flex-start;
  }
`
